import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";

export interface ILogonMessage {
  id: number;
  show_from: Date;
  show_to: Date;
  info: string;
  created_at: Date;
  updated_at: Date;
}

export class LogonMessage extends AbstractJSONModel implements ILogonMessage {
  id = -1;
  @Type(() => Date)
  show_from: Date = new Date();
  @Type(() => Date)
  show_to: Date = new Date();
  info = "";
  @Type(() => Date)
  created_at: Date = new Date();
  @Type(() => Date)
  updated_at: Date = new Date();
}
